import React, { useEffect, useMemo } from 'react'
import classnames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import MultiSelectBox from '../../../../features/components/Form/MultiSelectBox'

import {
  dv360TargetingOptionsSelector,
  getDv360TargetingOptionsIsLoadingSelector
} from '../../../../modules/selectors/dv360Constants'
import { clearGetDv360TargetingOptions, getDv360TargetingOptions } from '../../../../modules/actions/dv360Constants'
import { selectedDV360AdAccountSelector } from '../../../../modules/selectors/adAccounts'

import { targetingTypes } from '../../LineItemForms/LineItemDv360Create/fields'
import {
  CATEGORIES,
  EXCLUDED_CATEGORIES
} from '../../UploadDV360AdCreative/UploadDV360AdCreativeForm/LineItemForm/fields'

import useDrawerFormStyles from '../../../../styles/common/drawerForms'
import useStyles from './styles'

const CategoriesSection = ({ formik }) => {
  const classes = useStyles()
  const drawerFormClasses = useDrawerFormStyles()

  const dispatch = useDispatch()
  const { t } = useTranslation()

  const { values, setFieldValue } = formik

  const { id: selectedAdAccountId } = useSelector(selectedDV360AdAccountSelector)
  const dv360TargetingOptions = useSelector(dv360TargetingOptionsSelector)
  const getDv360TargetingOptionsIsLoading = useSelector(getDv360TargetingOptionsIsLoadingSelector)

  const formattedCategoryOptions = useMemo(() => {
    return dv360TargetingOptions.map(item => ({
      label: item.categoryDetails.displayName,
      value: item.targetingOptionId
    }))
  }, [dv360TargetingOptions])

  useEffect(() => {
    dispatch(
      getDv360TargetingOptions({
        account: selectedAdAccountId,
        targeting_type: targetingTypes.TARGETING_TYPE_CATEGORY
      })
    )
  }, [dispatch, selectedAdAccountId])

  useEffect(() => {
    return () => {
      dispatch(clearGetDv360TargetingOptions())
    }
  }, [dispatch])

  return (
    <section className={classnames(drawerFormClasses.section, classes.categoriesSection)}>
      <h3 className={drawerFormClasses.sectionTitle}>{t('Categories')}</h3>
      <MultiSelectBox
        placeholder={t('Add a category')}
        options={formattedCategoryOptions}
        name={CATEGORIES}
        value={values[CATEGORIES]}
        isLoading={getDv360TargetingOptionsIsLoading}
        setFieldValue={setFieldValue}
      />
      <h3 className={classnames(drawerFormClasses.sectionTitle, classes.excludeCategoriesTitle)}>
        {t('Exclude Categories')}
      </h3>
      <MultiSelectBox
        placeholder={t('Add a category')}
        options={formattedCategoryOptions}
        name={EXCLUDED_CATEGORIES}
        value={values[EXCLUDED_CATEGORIES]}
        isLoading={getDv360TargetingOptionsIsLoading}
        setFieldValue={setFieldValue}
      />
    </section>
  )
}

export default CategoriesSection
